jQuery("#shopify-section-template--16900528636061__1709121414701147e8").appendTo(".banner-content");jQuery(window).on("load",function(){jQuery("#shopify-block-convermax_year_make_model_verify_fitment_3MqtN4").insertBefore(".product-form__buttons")});function openTab(tabId){var tabContents=document.getElementsByClassName("tab-content");for(var i=0;i<tabContents.length;i++){tabContents[i].style.display="none"}var tabs=document.getElementsByClassName("tab");for(var i=0;i<tabs.length;i++){tabs[i].classList.remove("active-tab")}document.getElementById(tabId).style.display="block";document.querySelector("[onclick=\"openTab('"+tabId+"')\"]").classList.add("active-tab")}$(document).ready(function(){setTimeout(function(){jQuery(".verify-fitment-heading").on("click",function(){$(this).parent().addClass("open")});jQuery(".ymm-link").on("click",function(){$(".custom-ymm-form-body").addClass("open")})},3e3);return false});if($('.product-form__submit:contains("Call for Availability")').length>0){$(".product-form__buttons").addClass("not-available")}document.addEventListener("DOMContentLoaded",event=>{function lazyLoad(){const loadLately=document.querySelector(".loadLately");if(loadLately){const fallbackTimeout=setTimeout(function(){loadLately.style.display="block"},1e4);setTimeout(function(){requestAnimationFrame(function(){loadLately.innerHTML='<div class="elfsight-sapp-880eb013-6aa9-4fdf-9518-d2f7b25dd9d6"></div>';loadLately.style.display="block";clearTimeout(fallbackTimeout)})},4e3)}}window.addEventListener("load",lazyLoad);const images=document.querySelectorAll("img");if(images){images.forEach(img=>{if(!img.getAttribute("alt")){img.setAttribute("alt",img.getAttribute("src"))}if(!img.hasAttribute("height")){img.setAttribute("height","")}if(!img.hasAttribute("width")){img.setAttribute("width","")}})}const links=document.querySelectorAll(".ssw-share-faves, .terms-link, .ssw-hide, .ssw-ask-friends-btn");if(links){links.forEach(link=>{link.setAttribute("aria-hidden","true");link.setAttribute("aria-label","hidden arai attributes")})}});$(document).on("click touchend",".fancybox-container",function(e){if($(e.target).closest(".fancybox-navigation").length){return}if($(e.target).closest(".fancybox-toolbar").length){return}if($(e.target).closest(".fancybox-content").length){return}$.fancybox.close()});
/* ==========================================================================
   Rudy's Bucks — PDP earn badge enhancements
   1. Rewrites Appstle's badge label to "Earn 998 Rudy's Bucks ($9.98 in
      rewards)". The points number is Appstle's own; only the wording and the
      dollar equivalent are added.
   2. Appends a linked (i) icon pointing at the loyalty page, new tab.
   Appstle injects the badge with JS after load, so this watches for it.
   Pair with the .rb-info rules in custom.css.
   If the label ever stops matching, step 1 leaves the text untouched and
   step 2 still runs.
   ========================================================================== */
(function () {
  var SEL        = '.loyalty-acquire-points-badge.acquire-points-badge';
  var LABEL_SEL  = '.loyalty-acquire-earn-points-label';
  var PAGE       = '/pages/rudys-bucks';
  var TIP        = "How Rudy's Bucks work";
  var PER_DOLLAR = 100;   /* 100 Rudy's Bucks = $1 */
  var ICON = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false">'
           + '<circle cx="10" cy="10" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/>'
           + '<circle cx="10" cy="5.7" r="1.15" fill="currentColor"/>'
           + '<path d="M10 8.7v6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>'
           + '</svg>';

  function commas(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function relabel(badge) {
    var lbl = badge.querySelector(LABEL_SEL);
    if (!lbl || lbl.getAttribute('data-rb-done')) return;
    var m = (lbl.textContent || '').match(/([\d,]+)/);
    if (!m) return;                                  /* no number: leave it alone */
    var pts = parseInt(m[1].replace(/,/g, ''), 10);
    if (!pts || isNaN(pts)) return;
    var dollars = (pts / PER_DOLLAR).toFixed(2);
    lbl.textContent = 'Earn ' + commas(pts) + " Rudy's Bucks ($" + dollars + ' in rewards)';
    lbl.setAttribute('data-rb-done', '1');
  }

  function addLink(badge) {
    if (badge.querySelector('.rb-info')) return;
    var a = document.createElement('a');
    a.className = 'rb-info';
    a.href = PAGE;
    a.target = '_blank';
    a.rel = 'noopener';
    a.title = TIP;
    a.setAttribute('aria-label', TIP + ' (opens in a new tab)');
    a.innerHTML = ICON;
    badge.appendChild(a);
  }

  var queued = false;
  function scan() {
    queued = false;
    var found = document.querySelectorAll(SEL);
    for (var i = 0; i < found.length; i++) {
      relabel(found[i]);
      addLink(found[i]);
    }
  }
  function queue() {
    if (queued) return;
    queued = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(scan);
    else setTimeout(scan, 16);
  }

  queue();
  document.addEventListener('DOMContentLoaded', queue);

  /* Appstle renders late and re-renders on variant change. Watch, then stop. */
  if (window.MutationObserver) {
    var mo = new MutationObserver(queue);
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 30000);
  }
})();

/* ------------------------------------------------------------------
   Rudy's Bucks — FAQ sync for /apps/loyalty
   ------------------------------------------------------------------ */
(function () {
  if (location.pathname.indexOf('/apps/loyalty') !== 0) return;

  var SRC = '/pages/rudys-bucks';
  var done = false;

  function getRows(doc) {
    var section = doc.querySelector('[id^="shopify-section-"][id$="__faq"] .rte');
    if (!section) return [];
    var p = section.querySelector('p');
    var inner = p && p.parentElement;
    if (!inner) return [];
    return Array.prototype.slice.call(inner.children).filter(function (el) {
      return el.tagName === 'DIV' && el.children.length >= 2 && el.children[0].tagName === 'DIV';
    }).map(function (row) {
      return { title: row.children[0].textContent.trim(), html: row.children[1].innerHTML };
    }).filter(function (i) { return i.title; });
  }

  function toggle(item) {
    var open = item.classList.contains('appstleLoyaltyPageV2FaqListItemExpanded');
    var desc = item.querySelector('.appstleLoyaltyPageV2FaqListItemContentDescription');
    var icon = item.querySelector('.appstleLoyaltyPageV2FaqListItemIconContainer');
    item.classList.toggle('appstleLoyaltyPageV2FaqListItemExpanded', !open);
    item.classList.toggle('appstleLoyaltyPageV2FaqListItemCollapsed', open);
    if (desc) { desc.classList.toggle('al-hidden', open); desc.classList.toggle('al-block', !open); }
    if (icon) { icon.classList.toggle('al-rotate-180', !open); icon.classList.toggle('al-rotate-0', open); }
  }

  function render(items) {
    var list = document.querySelector('.appstleLoyaltyPageV2FaqList');
    var tpl = list && list.querySelector('.appstleLoyaltyPageV2FaqListItem');
    if (!list || !tpl || done) return false;
    var frag = document.createDocumentFragment();
    items.forEach(function (it) {
      var node = tpl.cloneNode(true);
      node.classList.add('appstleLoyaltyPageV2FaqListItemCollapsed');
      node.classList.remove('appstleLoyaltyPageV2FaqListItemExpanded');
      var t = node.querySelector('.appstleLoyaltyPageV2FaqListItemTitle');
      var d = node.querySelector('.appstleLoyaltyPageV2FaqListItemContentDescription');
      var ic = node.querySelector('.appstleLoyaltyPageV2FaqListItemIconContainer');
      if (!t || !d) return;
      t.textContent = it.title;
      d.innerHTML = it.html;
      d.classList.add('al-hidden'); d.classList.remove('al-block');
      if (ic) { ic.classList.add('al-rotate-0'); ic.classList.remove('al-rotate-180'); }
      node.setAttribute('data-rb-faq', '1');
      node.addEventListener('click', function () { toggle(node); });
      frag.appendChild(node);
    });
    if (!frag.childNodes.length) return false;
    while (list.firstChild) list.removeChild(list.firstChild);
    list.appendChild(frag);
    done = true;
    return true;
  }

  function start(items) {
    if (render(items)) return;
    var tries = 0;
    var t = setInterval(function () { if (render(items) || ++tries > 40) clearInterval(t); }, 250);
    // Appstle re-renders on login/state changes; re-apply if its list comes back.
    var mo = new MutationObserver(function () {
      var list = document.querySelector('.appstleLoyaltyPageV2FaqList');
      if (list && !list.querySelector('[data-rb-faq]')) { done = false; render(items); }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  fetch(SRC, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
    if (!html) return;
    var items = getRows(new DOMParser().parseFromString(html, 'text/html'));
    if (items.length) start(items);
  }).catch(function () {});
})();